export const stringOrNull = (value: string): string | null => (value ? value : null);
